// Reusable filter bar shown above the candidates table.
//
// showAddedByFilter controls whether the "Added by" dropdown renders at
// all — only ADMIN sees it, since a TEAM_LEAD/RECRUITER's list is already
// scoped to their own candidates server-side (see candidateController.js
// getCandidates), so filtering by a different user there would just
// return zero rows.
//
// "Technology applying for" options come from job titles used in existing
// optimizations (see JobTitleSelect / GET /optimization/job-titles).
//
// Styling: shares the base filter-bar look from ClientFilters.css
// (cf- classes) so both pages match; CandidateFilters.css only adds the
// column layout for this bar.

import JobTitleSelect from "./JobTitleSelect";
import "../css/ClientFilters.css";
import "../css/CandidateFilters.css";

export default function CandidateFilters({
  value,
  onChange,
  onApply,
  onReset,
  showAddedByFilter,
  users = [],
  clients = [],
}) {
  const set = (key) => (e) => onChange({ ...value, [key]: e.target.value });

  // Reset is only useful when at least one filter has a value.
  const hasAnyFilter = ["startDate", "endDate", "addedBy", "technology", "clientId"].some((k) => value[k]);

  const controlClass = (key) => `cf-control${value[key] ? " is-set" : ""}`;

  return (
    <div className="cf-bar">
      <div className={`cf-grid cf-grid-cand ${showAddedByFilter ? "cf-grid-cand-admin" : ""}`}>
        <div className="cf-field">
          <label htmlFor="cand-from">Added from</label>
          <input
            id="cand-from"
            type="date"
            className={controlClass("startDate")}
            value={value.startDate || ""}
            max={value.endDate || undefined}
            onChange={set("startDate")}
          />
        </div>

        <div className="cf-field">
          <label htmlFor="cand-to">Added to</label>
          <input
            id="cand-to"
            type="date"
            className={controlClass("endDate")}
            value={value.endDate || ""}
            min={value.startDate || undefined}
            onChange={set("endDate")}
          />
        </div>

        {showAddedByFilter && (
          <div className="cf-field">
            <label htmlFor="cand-added-by">Added by</label>
            <select
              id="cand-added-by"
              className={controlClass("addedBy")}
              value={value.addedBy || ""}
              onChange={set("addedBy")}
            >
              <option value="">Everyone</option>
              {users.map((u) => (
                <option key={u._id} value={u._id}>
                  {u.name} ({u.role === "TEAM_LEAD" ? "Team Lead" : "Recruiter"})
                </option>
              ))}
            </select>
          </div>
        )}

        {/* JobTitleSelect renders its own <select>; the wrapper class lets
            CandidateFilters.css style it like the other controls. */}
        <div className={`cf-field cf-field-jobtitle${value.technology ? " is-set" : ""}`}>
          <label>Technology applying for</label>
          <JobTitleSelect value={value.technology} onChange={set("technology")} />
        </div>

        <div className="cf-field">
          <label htmlFor="cand-client">Client</label>
          <select
            id="cand-client"
            className={controlClass("clientId")}
            value={value.clientId || ""}
            onChange={set("clientId")}
          >
            <option value="">All clients</option>
            {clients.map((c) => (
              <option key={c._id} value={c._id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        <div className="cf-actions">
          <button type="button" className="cf-btn cf-btn-secondary" onClick={onReset} disabled={!hasAnyFilter}>
            Reset
          </button>
          <button type="button" className="cf-btn cf-btn-primary" onClick={onApply}>
            Apply filters
          </button>
        </div>
      </div>
    </div>
  );
}
